import React from "react";

/**
 * OrderDetail Header Component
 * @param {Object} props
 * @param {string} props.stnSeq
 * @returns {React.JSX.Element}
 */
export default function Header({ stnSeq }) {
  return (
    <h1 className="page_title order-header" role="banner" tabIndex="-1">
      {`Order Details for SEWP Tracking Number (STN): ${stnSeq}`}
    </h1>
  );
}
